import { render, staticRenderFns } from "./schedule-popover.vue?vue&type=template&id=2091c612&scoped=true"
import script from "./schedule-popover.vue?vue&type=script&lang=js"
export * from "./schedule-popover.vue?vue&type=script&lang=js"
import style0 from "./schedule-popover.vue?vue&type=style&index=0&id=2091c612&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2091c612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2091c612')) {
      api.createRecord('2091c612', component.options)
    } else {
      api.reload('2091c612', component.options)
    }
    module.hot.accept("./schedule-popover.vue?vue&type=template&id=2091c612&scoped=true", function () {
      api.rerender('2091c612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/schedule-popover.vue"
export default component.exports